/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserActivityItem = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserActivityItem model module.
   * @module model/UserActivityItem
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserActivityItem</code>.
   * @alias module:model/UserActivityItem
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>UserActivityItem</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserActivityItem} obj Optional instance to populate.
   * @return {module:model/UserActivityItem} The populated <code>UserActivityItem</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FirstName')) {
        obj['FirstName'] = ApiClient.convertToType(data['FirstName'], 'String');
      }
      if (data.hasOwnProperty('LastName')) {
        obj['LastName'] = ApiClient.convertToType(data['LastName'], 'String');
      }
      if (data.hasOwnProperty('UserEmail')) {
        obj['UserEmail'] = ApiClient.convertToType(data['UserEmail'], 'String');
      }
      if (data.hasOwnProperty('TeamName')) {
        obj['TeamName'] = ApiClient.convertToType(data['TeamName'], 'String');
      }
      if (data.hasOwnProperty('RoleIdentifier')) {
        obj['RoleIdentifier'] = ApiClient.convertToType(data['RoleIdentifier'], 'String');
      }
      if (data.hasOwnProperty('CreatedDate')) {
        obj['CreatedDate'] = ApiClient.convertToType(data['CreatedDate'], 'Date');
      }
      if (data.hasOwnProperty('LastLoginDate')) {
        obj['LastLoginDate'] = ApiClient.convertToType(data['LastLoginDate'], 'Date');
      }
      if (data.hasOwnProperty('LoginCount')) {
        obj['LoginCount'] = ApiClient.convertToType(data['LoginCount'], 'Integer');
      }
      if (data.hasOwnProperty('CreatedActivityCount')) {
        obj['CreatedActivityCount'] = ApiClient.convertToType(data['CreatedActivityCount'], 'Integer');
      }
      if (data.hasOwnProperty('UpdatedActivityCount')) {
        obj['UpdatedActivityCount'] = ApiClient.convertToType(data['UpdatedActivityCount'], 'Integer');
      }
      if (data.hasOwnProperty('UserActivityStatus')) {
        obj['UserActivityStatus'] = ApiClient.convertToType(data['UserActivityStatus'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} FirstName
   * @default ''
   */
  exports.prototype['FirstName'] = '';
  /**
   * @member {String} LastName
   * @default ''
   */
  exports.prototype['LastName'] = '';
  /**
   * @member {String} UserEmail
   * @default ''
   */
  exports.prototype['UserEmail'] = '';
  /**
   * @member {String} TeamName
   * @default ''
   */
  exports.prototype['TeamName'] = '';
  /**
   * @member {String} RoleIdentifier
   * @default ''
   */
  exports.prototype['RoleIdentifier'] = '';
  /**
   * @member {Date} CreatedDate
   */
  exports.prototype['CreatedDate'] = undefined;
  /**
   * @member {Date} LastLoginDate
   */
  exports.prototype['LastLoginDate'] = undefined;
  /**
   * @member {Integer} LoginCount
   * @default 0
   */
  exports.prototype['LoginCount'] = 0;
  /**
   * @member {Integer} CreatedActivityCount
   * @default 0
   */
  exports.prototype['CreatedActivityCount'] = 0;
  /**
   * @member {Integer} UpdatedActivityCount
   * @default 0
   */
  exports.prototype['UpdatedActivityCount'] = 0;
  /**
   * @member {Integer} UserActivityStatus
   * @default 0
   */
  exports.prototype['UserActivityStatus'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


